import { InjectionToken } from '@angular/core';
import { ConsumptionType } from '@shared/consumption';

export const supportedConsumptionTypes = new InjectionToken<string[]>('supportedConsumptionTypes');
export const supportedConsumptionTypesFactory = () => Object.keys(ConsumptionType).map((type) => type.toUpperCase());
